import AtomicSpinner from "atomic-spinner";
import React from "react";

type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl";

interface SpinnerProps {
  size?: SpinnerSize;
  label?: string;
  className?: string;
  inline?: boolean;
}

const SIZE_PX: Record<SpinnerSize, number> = {
  xs: 20,
  sm: 28,
  md: 48,
  lg: 72,
  xl: 112,
};

// All-orange palette. Slight tonal variation keeps electrons distinguishable
// while staying within the brand colour.
const ORANGE_PALETTE = ["#f97316", "#fb923c", "#ea580c", "#fdba74"];
const ORANGE_PATH = "#fed7aa";
const ORANGE_NUCLEUS = "#f97316";

const Spinner: React.FC<SpinnerProps> = ({
  size = "md",
  label,
  className = "",
  inline = false,
}) => {
  const atomSize = SIZE_PX[size];

  const Wrapper: React.ElementType = inline ? "span" : "div";
  const layoutClass = inline
    ? "inline-flex items-center gap-2 align-middle"
    : "flex items-center justify-center gap-2";

  return (
    <Wrapper
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={`${layoutClass} ${className}`}
    >
      <AtomicSpinner
        atomSize={atomSize}
        electronColorPalette={ORANGE_PALETTE}
        electronPathColor={ORANGE_PATH}
        nucleusParticleFillColor={ORANGE_NUCLEUS}
        nucleusParticleBorderColor={ORANGE_NUCLEUS}
      />
      {label ? (
        <span className="typo-caption text-muted-foreground">{label}</span>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </Wrapper>
  );
};

export default Spinner;
